import Zone from "@insite/client-framework/Components/Zone";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideHeader,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import CategoryList, { categoryListStyles } from "@insite/content-library/Widgets/Category/CategoryList";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Page from "@insite/mobius/Page";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import React from "react";
import { css } from "styled-components";

const HomePage: React.FunctionComponent<PageProps> = ({ id }) => (
    <Page
        fullWidth={[true, true, true, true, true]}
        css={css`
            padding: 0px;
            background: #f7fafc;
            [class^="GridWrapper"] {
                &:nth-child(1) {
                    margin: auto;
                    [class^="BannerContainer"] {
                        z-index: 0;
                        position: relative;
                        display: flex;
                        flex-direction: row;
                        background-repeat: no-repeat;
                        color: #f7fafc;
                        min-height: 135.33px;
                        > div {
                            margin: auto;
                            z-index: 2;
                            button {
                                padding: 8px 16px;
                            }
                        }
                        > div[class^="bannerImage"] {
                            z-index: 1;
                            position: absolute;
                            width: 100%;
                            [class^="LazyImageStyle"] {
                                width: 100%;
                            }
                            img {
                                max-height: 135px;
                            }
                        }
                        div[class="BannerButton"] {
                            button {
                                font-size: 16px;
                                color: #f7fafc;
                                background-color: #008061;
                                width: 120px;
                                cursor: pointer;
                            }
                        }
                    }
                    [class^="getStartedContainer"] {
                        z-index: 0;
                        position: relative;
                        display: flex;
                        flex-direction: row;
                        background-repeat: no-repeat;
                        color: #f7fafc;
                        min-height: 135.33px;
                        > div {
                            margin: auto;
                            z-index: 2;
                            button {
                                padding: 8px 16px;
                            }
                        }
                        > div[class^="bannerImage"] {
                            z-index: 1;
                            position: absolute;
                            width: 100%;
                            [class^="LazyImageStyle"] {
                                width: 100%;
                            }
                            img {
                                max-height: 135px;
                            }
                        }
                        div[class="BannerButton"] {
                            button {
                                font-size: 16px;
                                color: #f7fafc;
                                background-color: #008061;
                                width: 120px;
                                cursor: pointer;
                            }
                        }
                    }
                    [class^="ChatWithUsContainer"] {
                        z-index: 0;
                        display: flex;
                        flex-direction: row;
                        background-repeat: no-repeat;
                        color: #f7fafc;
                        min-height: 135.33px;
                        position: relative;
                        > div {
                            margin: auto;
                            z-index: 2;
                            button {
                                padding: 8px 16px;
                            }
                        }
                        > div[class^="bannerImage"] {
                            z-index: 1;
                            position: absolute;
                            width: 100%;
                            [class^="LazyImageStyle"] {
                                width: 100%;
                            }
                            img {
                                max-height: 135px;
                            }
                        }
                        div[class="BannerButton"] {
                            button {
                                font-size: 16px;
                                color: #f7fafc;
                                background-color: #008061;
                                width: 120px;
                                cursor: pointer;
                            }
                        }
                    }
                }
                &:nth-child(2) {
                    padding-right: 15px;
                    padding-left: 15px;
                    margin: auto;
                    [class^="GridOffset"] {
                        [class^="GridItemStyle"] {
                            ${({ theme }: { theme: BaseTheme }) =>
                                breakpointMediaQueries(theme, [
                                    css`
                                        flex-basis: 100%;
                                        max-width: 100%;
                                        &:nth-child(2) {
                                            [class^="BannerContainer"] {
                                                min-height: 96px;
                                                [class^="ImageIcons"] {
                                                    img {
                                                        width: 75%;
                                                    }
                                                }
                                                [class^="BannerButton"] {
                                                    button {
                                                        padding: 7px 0px;
                                                        font-size: 14px;
                                                        margin-right: 6px;
                                                    }
                                                }
                                                [class^="BannerText"] {
                                                    p {
                                                        font-size: 12px !important;
                                                        // margin-left: 10px;
                                                        // white-space: nowrap;
                                                        // text-overflow: ellipsis;
                                                        // width: 130px;
                                                        // display: block;
                                                        // overflow: hidden;
                                                    }
                                                }
                                            }
                                            [class^="getStartedContainer"] {
                                                min-height: 96px;
                                                [class^="ImageIcons"] {
                                                    img {
                                                        width: 75%;
                                                    }
                                                }
                                                [class^="BannerButton"] {
                                                    button {
                                                        padding: 7px 0px;
                                                        font-size: 14px;
                                                        margin-right: 6px;
                                                    }
                                                }
                                                [class^="BannerText"] {
                                                    p {
                                                        font-size: 12px !important;
                                                        // margin-left: 10px;
                                                        // white-space: nowrap;
                                                        // text-overflow: ellipsis;
                                                        // width: 130px;
                                                        // display: block;
                                                        // overflow: hidden;
                                                    }
                                                }
                                            }
                                            [class^="ChatWithUsContainer"] {
                                                min-height: 96px;
                                                [class^="ImageIcons"] {
                                                    img {
                                                        width: 75%;
                                                    }
                                                }
                                                [class^="BannerButton"] {
                                                    button {
                                                        padding: 7px 0px;
                                                        font-size: 14px;
                                                        margin-right: 6px;
                                                    }
                                                }
                                                [class^="BannerText"] {
                                                    p {
                                                        font-size: 12px !important;
                                                        // margin-left: 10px;
                                                        // white-space: nowrap;
                                                        // text-overflow: ellipsis;
                                                        // width: 130px;
                                                        // display: block;
                                                        // overflow: hidden;
                                                    }
                                                }
                                            }
                                        }
                                    `,
                                    css`
                                        flex-basis: 100%;
                                        max-width: 100%;
                                    `,
                                    css`
                                        flex-basis: 100%;
                                        max-width: 100%;
                                    `,
                                    null,
                                    null,
                                ])}
                        }
                        > div:first-child {
                            [class^="Wrapper"] {
                                &:first-child > div:first-child {
                                    padding: 0px;
                                }
                            }
                        }
                        button {
                            border: 1px solid #008061;
                            svg {
                                color: #008061;
                            }
                        }
                    }
                }
                &:nth-child(3) {
                    padding-right: 0px;
                    padding-left: 0px;
                    margin: auto;
                    > div[class^="GridOffset"] {
                        width: 100%;
                        margin: 0 auto;
                    }
                }

                &:nth-child(4) {
                    margin: auto;
                    > div[class^="GridOffset"] {
                        width: 100%;
                        margin: 0 auto;
                    }
                }

                &:nth-child(5) {
                    margin: auto;
                    > div[class^="GridOffset"] {
                        width: 100%;
                        margin: 0 auto;
                    }
                    [class^="GridWrapper"]:nth-child(1) {
                        [class^="GridItemStyle"]:nth-child(2) {
                            [class^="Wrapper"]:nth-child(1) {
                                background-color: #fff;
                                padding: 10px;
                                height: 100%;
                                button {
                                    border: 2px solid #3b7e63;
                                    color: #3b7e63;
                                    margin-bottom: 4px;
                                    &:hover {
                                        background-color: #3b7e63;
                                        color: #fff !important;
                                        border: 1px solid #3b7e63;
                                    }
                                }
                            }
                        }
                    }
                    [class="locationContainer"] {
                        background-color: #fff;
                        padding: 8px;
                        [class="viewAll"] {
                            margin: auto;
                            border: 2px solid #3b7e63;
                            color: #3b7e63;
                            background-color: #fff;
                            padding: 8px 22px;
                            display: block;
                            font-size: 16px;
                            font-weight: bold;
                            cursor: pointer;
                            &:hover {
                                background-color: #3b7e63;
                                color: #fff;
                            }
                        }
                    }
                }
            }
        `}
    >
        <Zone contentId={id} zoneName="Content" requireRows />
        <Modals />
    </Page>
);

const pageModule: PageModule = {
    component: HomePage,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "System",
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            HideHeader,
            HideFooter,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
        ],
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "HomePage" instead of this constant.
 */
export const HomePageContext = "HomePage";
